(() => {

	async function fetchCartItems() {
		try {
			const response = await fetch('/cart.js', { cache: 'no-store' });
			if (!response.ok) throw new Error(`Failed to fetch cart: ${response.status}`);
			const cartData = await response.json();
			return cartData.items || [];
		} catch {
			return [];
		}
	}

	async function wrapCartElements() {
		const cartItems = await fetchCartItems();
		if (!cartItems.length) return;

		cartItems.forEach((item, index) => {
			const lineElement = document.querySelector(`.cd-product-item:nth-child(${index + 1})`);
			if (!lineElement) return;

			const priceElement = lineElement.querySelector('.opus-price-display .opus-final-price');
			if (priceElement) {
				priceElement.setAttribute('data-hulkapps-line-price', '');
				priceElement.setAttribute('data-key', item.key);
			}

			const propertyElements = lineElement.querySelectorAll('.cd-product-item-options');
			propertyElements.forEach(lineItem => {
				let textContent = null;

				for (let i = lineItem.childNodes.length - 1; i >= 0; i--) {
					const node = lineItem.childNodes[i];
					if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
						textContent = node.textContent.trim();
						node.textContent = '';
						break;
					}
				}

				if (textContent && !lineItem.querySelector('.hpo-price')) {
					const span = document.createElement('span');
					span.className = 'hpo-price';
					span.textContent = textContent;
					lineItem.appendChild(span);
				}
			});
		});

		const cartTotal = document.querySelector('[id^="opus-checkout-btn"] span.opus-price');
		if (cartTotal) {
			cartTotal.setAttribute('data-hulkapps-cart-total', '');
		}

		if (typeof window.getCartInfo === 'function') {
			window.getCartInfo();
		}
	}

	function debounce(func, delay = 1000) {
		let timer;
		return (...args) => {
			clearTimeout(timer);
			timer = setTimeout(() => func(...args), delay);
		};
	}

	const debouncedWrap = debounce(wrapCartElements, 1200);

	function observeCartTotal() {
		const target = document.querySelector('[id^="opus-checkout-btn"] .opus-price');
		console.log(target, 'observation target');
		if (!target) return;

		const observer = new MutationObserver(mutations => {
			for (const mutation of mutations) {
				console.log(mutation.type);
				if (!mutation.target.getAttribute('data-hulkapps-cart-total') && mutation.type != 'childList') {
					console.log('Here');
					wrapCartElements();
				}
			}
		});

		observer.observe(target, { childList: true, characterData: true, subtree: true });
	}

	function opusCartIntegration() {
    document.querySelector('#hulk-loader')?.remove();
		document.body.addEventListener('click', e => {
			if (
        e.target.closest('.hulkapps_submit_cart') ||
				e.target.closest('.opus-addons-container .cd-toggle-switch') ||
				e.target.closest('.cd-number-input-button') ||
				e.target.closest('.cd-product-item-delete') || e.target.closest('#CartToggleItemCount') || e.target.closest('.hulkapps_submit_cart')
			) {
				debouncedWrap();
			}
		},!0);

		const opusContainer = document.querySelector('.cd-opus-container');
		if (opusContainer) {
			opusContainer.addEventListener('change', debouncedWrap);
		}

		observeCartTotal();

		document.body.addEventListener(
			'click',
			e => {
				if (e.target.closest('.opus-btn-checkout') && window.is_draft_order) {
					e.preventDefault();
					e.stopImmediatePropagation();
					e.stopPropagation();
					if (typeof window.hulkappsCheckout === 'function') {
						window.hulkappsCheckout();
					}
				}
			},
			true
		);

		wrapCartElements();
	}

	if (document.readyState === 'complete' || document.readyState === 'interactive') {
		opusCartIntegration();
	} else {
		window.addEventListener('load', opusCartIntegration);
	}
})();
